export default __webpack_public_path__ + "static/media/ic_info.9872af23.svg";